import { html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { StyleInfo, styleMap } from 'lit/directives/style-map';
import { toKebabCase } from '../common/utils';
import { TeComponent } from '../common/te-component';
import { theme } from '../common/theme';
import '../te-spacing';
import '../te-text';

/**
 * Label Simple Component
 */
@customElement('te-label-simple')
export class TeLabelSimple extends TeComponent {
  static styles = [
    ...TeComponent.styles,
    css`
      .label-simple {
        box-sizing: content-box;
        display: block;
        height: 8px;
        width: 8px;
        border: 2px solid ${theme.colors.shade0};
        border-radius: 50%;
      }

      .top-right {
        right: -2px;
        top: -2px;
      }

      .top-left {
        left: -2px;
        top: -2px;
      }

      .bottom-right {
        right: -2px;
        bottom: -2px;
      }

      .bottom-left {
        left: -2px;
        bottom: -2px;
      }
    `,
  ];

  /** Background color of label */
  @property({ type: String }) backgroundColor = theme.colors.primary.v0.toString();
  /** Border color of label */
  @property({ type: String }) borderColor?: string;
  /** Relative placement of label inside parent  */
  @property({ type: String }) placement?: 'topRight' | 'topLeft' | 'bottomLeft' | 'bottomRight';

  getStyle(): StyleInfo {
    return {
      backgroundColor: this.backgroundColor,
      position: this.placement ? 'absolute' : 'relative',
      border: this.borderColor ? `2px solid ${this.borderColor}` : 'unset',
    };
  }

  render() {
    const placement = this.placement ? this.placement : '';
    const classes = `
     label-simple ${toKebabCase(placement)}`.trim();
    return html`
      <span class=${classes} style=${styleMap(this.getStyle())}></span>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'te-label-simple': TeLabelSimple;
  }
}
